/**
 * The public pages nginx serves at the site root, outside this Angular app.
 *
 * Every Terms / Privacy / Support link points here so the three destinations
 * live in one place. They used to be a mix of in-app routes (/terms/sh,
 * /privacy-policy/sh), modal dialogs, bare root-relative paths and one
 * hardcoded askbuddy.ai URL - four ways to reach two documents.
 */
export const SITE_LINKS = {
  terms: 'https://liam.askbuddy.ai/terms',
  privacy: 'https://liam.askbuddy.ai/privacy',
  support: 'https://liam.askbuddy.ai/support',
} as const;
